import initCustomerCare from '@sectionsJS/customer-care';

$(async () => {
  initCustomerCare();
});
